import { forwardRef, type SVGProps } from 'react';

export const PriceCheckIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function PriceCheckIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1621_10945)">
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="4" />
        <path
          d="M15.6 17.5625V25.875C15.6 27.185 16.6763 28.25 18 28.25H33.6C34.9238 28.25 36 27.185 36 25.875V17.5625C36 16.2525 34.9238 15.1875 33.6 15.1875H18C16.6763 15.1875 15.6 16.2525 15.6 17.5625ZM18 23.5C19.3238 23.5 20.4 24.565 20.4 25.875H18V23.5ZM20.4 17.5625C20.4 18.8725 19.3238 19.9375 18 19.9375V17.5625H20.4ZM33.6 23.5V25.875H31.2C31.2 24.565 32.2763 23.5 33.6 23.5ZM31.2 17.5625H33.6V19.9375C32.2763 19.9375 31.2 18.8725 31.2 17.5625ZM22.8 21.7188C22.8 20.9314 23.1161 20.1763 23.6787 19.6195C24.2413 19.0628 25.0044 18.75 25.8 18.75C26.5957 18.75 27.3587 19.0628 27.9213 19.6195C28.4839 20.1763 28.8 20.9314 28.8 21.7188C28.8 22.5061 28.4839 23.2612 27.9213 23.818C27.3587 24.3747 26.5957 24.6875 25.8 24.6875C25.0044 24.6875 24.2413 24.3747 23.6787 23.818C23.1161 23.2612 22.8 22.5061 22.8 21.7188ZM13.8 18.4531C13.8 17.9596 13.3988 17.5625 12.9 17.5625C12.4013 17.5625 12 17.9596 12 18.4531V27.3594C12 29.8197 14.0137 31.8125 16.5 31.8125H31.5C31.9988 31.8125 32.4 31.4154 32.4 30.9219C32.4 30.4283 31.9988 30.0312 31.5 30.0312H16.5C15.0075 30.0312 13.8 28.8363 13.8 27.3594V18.4531Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_10945">
          <rect fill="white" height="48" width="48" />
        </clipPath>
      </defs>
    </svg>
  );
});
